// extracted by mini-css-extract-plugin
export default {"compareScanTable":"ZS9RkzrettgplEUxVSZr"};